/*
 * Kidily bundle product page (sections/kd-product-bundle.liquid).
 *
 * - Gallery: swipeable scroll-snap track, arrows and thumbnails.
 * - Bundle: the chosen offer shows one picker per product option for each unit. Add to cart sends every
 *   chosen variant in one /cart/add.js request (identical choices merged into one quantity).
 *   Prices are never changed here: Shopify's automatic discounts apply in the cart. Afterwards
 *   the cart is read back, and if a discounted offer got no discount the shopper is told.
 * - Mobile sticky bar appears once the main button has scrolled out of view.
 */
(function () {
  function formatMoney(cents, format) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function noTrailingZeros(money) {
    return money.replace(/([.,])00(?!\d)/, '');
  }

  function initGallery(root) {
    var gallery = root.querySelector('[data-kdp-gallery]');
    if (!gallery) return;
    var track = gallery.querySelector('[data-kdp-track]');
    var slides = gallery.querySelectorAll('[data-kdp-slide]');
    var thumbs = gallery.querySelectorAll('[data-kdp-thumb]');
    var count = gallery.querySelector('[data-kdp-count]');
    var current = 0;

    function goTo(index) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    }

    function setActive(index) {
      if (index === current) return;
      current = index;
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
        if (i === index) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      if (count) count.textContent = index + 1 + ' / ' + slides.length;
      // Pause videos that are no longer shown.
      slides.forEach(function (slide, i) {
        if (i === index) return;
        slide.querySelectorAll('video').forEach(function (video) { video.pause(); });
      });
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        setActive(Math.round(track.scrollLeft / track.clientWidth));
        ticking = false;
      });
    }, { passive: true });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { goTo(Number(thumb.dataset.kdpThumb)); });
    });
    var prev = gallery.querySelector('[data-kdp-prev]');
    var next = gallery.querySelector('[data-kdp-next]');
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    track.addEventListener('keydown', function (evt) {
      if (evt.key === 'ArrowLeft') { evt.preventDefault(); goTo(current - 1); }
      if (evt.key === 'ArrowRight') { evt.preventDefault(); goTo(current + 1); }
    });
  }

  function initSizeGuide(root) {
    var dialog = root.querySelector('[data-kdp-size-guide]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    root.querySelectorAll('[data-kdp-size-guide-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { dialog.showModal(); });
    });
    dialog.querySelector('[data-kdp-size-guide-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (evt) {
      if (evt.target === dialog) dialog.close();
    });
  }

  function initBundle(root) {
    var data = JSON.parse(root.querySelector('[data-kdp-data]').textContent);
    var form = root.querySelector('[data-kdp-form]');
    var offers = root.querySelectorAll('.kdp-offer__input');
    var units = root.querySelectorAll('[data-kdp-pair]');
    var atc = root.querySelector('[data-kdp-atc]');
    var atcLabel = root.querySelector('[data-kdp-atc-label]');
    var message = root.querySelector('[data-kdp-message]');
    var sticky = root.querySelector('[data-kdp-sticky]');
    var stickyTitle = root.querySelector('[data-kdp-sticky-title]');
    var stickyPrice = root.querySelector('[data-kdp-sticky-price]');
    var stickyBtn = root.querySelector('[data-kdp-sticky-btn]');
    var busy = false;

    var fromNote = root.querySelector('[data-kdp-from]');
    if (fromNote && data.fromLabel && data.bestPerPair < data.unitPrice) {
      fromNote.textContent = data.fromLabel.replace('{price}', noTrailingZeros(formatMoney(data.bestPerPair, data.moneyFormat)));
      fromNote.hidden = false;
    }

    var qtyInput = root.querySelector('[data-kdp-qty-input]');
    var unitPriceEl = root.querySelector('[data-kdp-unit-price]');

    function quantity() {
      if (!qtyInput) return 1;
      var q = Math.floor(Number(qtyInput.value));
      return q > 0 ? Math.min(q, 99) : 1;
    }

    function selectedOffer() {
      var input = root.querySelector('.kdp-offer__input:checked');
      if (!input) return { units: 1, price: null, discounted: false, title: '', label: data.labelSingle };
      return {
        units: Number(input.dataset.pairs),
        price: Number(input.dataset.price),
        discounted: input.dataset.discounted === 'true',
        title: input.dataset.title,
        label: input.dataset.label
      };
    }

    // One value per product option for a unit; null where the shopper has not chosen yet.
    function unitChoice(unit) {
      var values = data.options.map(function () { return null; });
      unit.querySelectorAll('[data-kdp-option]').forEach(function (el) {
        var index = Number(el.dataset.kdpOption);
        if (el.type === 'radio') { if (el.checked) values[index] = el.value; }
        else if (el.value) values[index] = el.value;
      });
      return values;
    }

    function matches(variant, values) {
      return values.every(function (value, i) { return value === null || variant.options[i] === value; });
    }

    function findVariant(values) {
      if (!data.hasOptions) return data.variants[0];
      if (values.some(function (v) { return v === null; })) return null;
      return data.variants.find(function (v) { return matches(v, values); });
    }

    // Disable values that cannot be bought with the unit's other choices.
    function refreshAvailability(unit) {
      var values = unitChoice(unit);
      unit.querySelectorAll('select[data-kdp-option]').forEach(function (select) {
        var index = Number(select.dataset.kdpOption);
        Array.prototype.forEach.call(select.options, function (opt) {
          if (!opt.value) return;
          var test = values.slice();
          test[index] = opt.value;
          var available = data.variants.some(function (v) { return v.available && matches(v, test); });
          opt.disabled = !available;
          opt.textContent = opt.value + (available ? '' : ' — ' + data.soldOutLabel);
        });
        if (select.value && select.selectedOptions[0].disabled) select.value = '';
      });
      unit.querySelectorAll('[data-kdp-swatch]').forEach(function (input) {
        var index = Number(input.dataset.kdpOption);
        var any = data.variants.some(function (v) { return v.available && v.options[index] === input.value; });
        input.disabled = !any;
        input.nextElementSibling.classList.toggle('is-unavailable', !any);
      });
      var checked = unit.querySelector('[data-kdp-swatch]:checked');
      var name = unit.querySelector('[data-kdp-color-name]');
      if (name && checked) name.textContent = checked.value;
    }

    function total() {
      var offer = selectedOffer();
      if (offer.discounted) return offer.price;
      if (!data.hasOffers) {
        var single = units.length ? findVariant(unitChoice(units[0])) : data.variants[0];
        return (single ? single.price : data.unitPrice) * quantity();
      }
      var sum = 0;
      for (var i = 0; i < offer.units; i++) {
        var v = data.hasOptions ? findVariant(unitChoice(units[i])) : data.variants[0];
        sum += v ? v.price : data.unitPrice;
      }
      return sum;
    }

    function render() {
      var offer = selectedOffer();
      units.forEach(function (unit, i) { unit.hidden = i >= offer.units; });
      var money = formatMoney(total(), data.moneyFormat);
      if (!atc.disabled || busy) {
        atcLabel.textContent = offer.label.replace('{qty}', offer.units).replace('{price}', money);
      }
      if (!data.hasOffers && unitPriceEl && units.length) {
        var v = findVariant(unitChoice(units[0]));
        if (v) unitPriceEl.textContent = formatMoney(v.price, data.moneyFormat);
      }
      if (stickyTitle && offer.title) stickyTitle.textContent = offer.title;
      if (stickyPrice) stickyPrice.textContent = money;
    }

    function setError(unit, text) {
      var el = unit.querySelector('[data-kdp-error]');
      el.textContent = text || '';
      unit.classList.toggle('has-error', !!text);
    }

    function showMessage(text, tone) {
      message.textContent = text;
      message.dataset.tone = tone || 'info';
      message.hidden = !text;
    }

    units.forEach(function (unit, index) {
      refreshAvailability(unit);
      unit.addEventListener('change', function (evt) {
        refreshAvailability(unit);
        if (evt.target.matches('select[data-kdp-option]')) {
          setError(unit, '');
          // A menu choice on the first unit is copied to later units that have not chosen yet.
          if (index === 0 && evt.target.value) {
            units.forEach(function (other, i) {
              if (i === 0) return;
              var select = other.querySelector('select[data-kdp-option="' + evt.target.dataset.kdpOption + '"]');
              if (select && !select.value) {
                var opt = Array.prototype.find.call(select.options, function (o) { return o.value === evt.target.value; });
                if (opt && !opt.disabled) {
                  select.value = evt.target.value;
                  refreshAvailability(other);
                }
              }
            });
          }
        }
        render();
      });
    });

    offers.forEach(function (input) {
      input.addEventListener('change', function () {
        units.forEach(function (unit) { setError(unit, ''); });
        showMessage('');
        render();
      });
    });

    if (qtyInput) {
      root.querySelectorAll('[data-kdp-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          qtyInput.value = Math.max(1, Math.min(99, quantity() + Number(btn.dataset.kdpQty)));
          render();
        });
      });
      qtyInput.addEventListener('change', function () {
        qtyInput.value = quantity();
        render();
      });
    }

    function collectItems() {
      var offer = selectedOffer();
      if (!data.hasOptions) {
        return [{ id: data.variants[0].id, quantity: data.hasOffers ? offer.units : quantity() }];
      }
      var items = [];
      var firstInvalid = null;
      var count = data.hasOffers ? offer.units : 1;
      for (var i = 0; i < count; i++) {
        var unit = units[i];
        var values = unitChoice(unit);
        var itemLabel = count > 1 ? data.unitTitle + ' ' + (i + 1) : 'your ' + data.unitTitle.toLowerCase();
        var missing = values.indexOf(null);
        if (missing !== -1) {
          setError(unit, data.chooseError.replace('{option}', data.options[missing].name.toLowerCase()).replace('{item}', itemLabel));
          firstInvalid = firstInvalid || unit;
          continue;
        }
        var variant = findVariant(values);
        if (!variant || !variant.available) {
          setError(unit, values.join(' / ') + ' is sold out. Please choose another option.');
          firstInvalid = firstInvalid || unit;
          continue;
        }
        setError(unit, '');
        var qty = data.hasOffers ? 1 : quantity();
        var existing = items.find(function (item) { return item.id === variant.id; });
        if (existing) existing.quantity += qty;
        else items.push({ id: variant.id, quantity: qty });
      }
      if (firstInvalid) {
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var empty = Array.prototype.find.call(firstInvalid.querySelectorAll('select[data-kdp-option]'), function (sel) { return !sel.value; });
        if (empty) setTimeout(function () { empty.focus({ preventScroll: true }); }, 350);
        return null;
      }
      return items;
    }

    // Read the cart back: a discounted offer whose lines carry no discount means the
    // automatic discount did not apply, so say so rather than leave a silent mismatch.
    function checkDiscount(offer) {
      if (!offer.discounted || !data.discountMissing) return;
      fetch(data.cartUrl + '.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var lines = cart.items.filter(function (item) { return String(item.product_id) === root.dataset.productId; });
          var discount = lines.reduce(function (sum, item) { return sum + (item.original_line_price - item.final_line_price); }, 0);
          if (lines.length && discount === 0) showMessage(data.discountMissing, 'warning');
        })
        .catch(function () {});
    }

    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      if (busy || atc.disabled) return;
      showMessage('');
      var items = collectItems();
      if (!items) return;
      var offer = selectedOffer();

      busy = true;
      atc.classList.add('is-loading');
      atc.setAttribute('aria-busy', 'true');
      if (stickyBtn) stickyBtn.disabled = true;

      fetch(data.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          return res.json().then(function (body) { return { ok: res.ok, body: body }; });
        })
        .then(function (result) {
          if (!result.ok || result.body.status) {
            showMessage(result.body.description || result.body.message || 'Sorry, that could not be added to your cart.', 'error');
            return;
          }
          var added = result.body.items || [];
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: { product: added[0], items: added, addToCartBtn: atc }
          }));
          if (!window.theme || !theme.settings || theme.settings.cartType !== 'drawer') {
            window.location.href = data.cartUrl;
            return;
          }
          checkDiscount(offer);
        })
        .catch(function () {
          showMessage('Sorry, something went wrong. Please check your connection and try again.', 'error');
        })
        .finally(function () {
          busy = false;
          atc.classList.remove('is-loading');
          atc.removeAttribute('aria-busy');
          if (stickyBtn) stickyBtn.disabled = false;
        });
    });

    if (sticky && stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
      // Shown only once the main button is above the viewport. A scroll check rather than an
      // IntersectionObserver, which misses jumps from below the button straight to above it.
      var shown = false;
      var pendingFrame = false;
      var updateSticky = function () {
        pendingFrame = false;
        var show = atc.getBoundingClientRect().bottom < 0;
        if (show === shown) return;
        shown = show;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        stickyBtn.tabIndex = show ? 0 : -1;
      };
      window.addEventListener('scroll', function () {
        if (pendingFrame) return;
        pendingFrame = true;
        requestAnimationFrame(updateSticky);
      }, { passive: true });
      updateSticky();
    }

    render();
  }

  function setHeaderOffset() {
    var header = document.querySelector('.site-header');
    if (header) document.documentElement.style.setProperty('--kdp-header', header.offsetHeight + 'px');
  }

  // Rating under the title from the reviews section's summary, when Liquid had none to show.
  function initRating(root) {
    var link = root.querySelector('[data-kdp-rating]');
    var source = document.querySelector('[data-kdr-summary]');
    if (!link || !source) return;
    var summary = JSON.parse(source.dataset.kdrSummary);
    if (!summary.count) return;
    link.querySelector('[data-kdp-rating-stars]').style.setProperty('--kd-rating', summary.rating * 20 + '%');
    link.querySelector('[data-kdp-rating-value]').textContent = summary.rating;
    link.querySelector('[data-kdp-rating-count]').textContent = '(' + summary.count + (summary.count === 1 ? ' review)' : ' reviews)');
    link.setAttribute('aria-label', summary.rating + ' out of 5 stars from ' + summary.count + ' reviews. Go to reviews.');
    link.hidden = false;
  }

  function init() {
    document.querySelectorAll('[data-kdp]').forEach(function (root) {
      if (root.dataset.kdpReady) return;
      root.dataset.kdpReady = 'true';
      initGallery(root);
      initSizeGuide(root);
      initBundle(root);
      initRating(root);
    });
    setHeaderOffset();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('resize', setHeaderOffset, { passive: true });
})();
